import React, { useContext, useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import useApiFunction from "../../api/useApiFunction";
import valueContext from "../../customHook/useContext";

function IncentiveReport() {
  const { joinToken } = useContext(valueContext);

  const token = joinToken();

  const [data, setData] = useState("");
  const [searchData, setSearchData] = useState("");
  const [core, setCore] = useState("");

  const [search, setSearch] = useState({});

  function searchChange(e) {
    setSearch(e.target.value);
  }

  const { formDataFunc } = useApiFunction();
  const navigate = useNavigate();
  function Search() {
    if (search) {
      const filteredData = data.filter(dataItem => dataItem.userName == search);

      setSearchData(filteredData);
      setSearch("");
    } else {
      toast.warning("Please fill some input", { autoClose: 1000 });
      setSearchData(data);
      setSearch("");
    }
  }

  function SearchCore(core) {
    if (core == 3) {
      setSearchData(data);
      setSearch("");
    } else if (core == 1 || core == 2) {
      const filteredData = data.filter(dataItem => dataItem.core == core);
      setSearchData(filteredData);
      setSearch("");
    } else {
      // toast.warning("Please fill some input", { autoClose: 1000 });
      setSearchData(data);
      setSearch("");
    }
  }
  async function getData() {
    const res = await formDataFunc(
      "admin/incentive-reports",
      JSON.stringify({}),
      "POST",
      token
    );
    if (res.status) {
      setData(res.msg);
      setSearchData(res.msg);
    } else if (
      res.error &&
      (res.error === "ERROR_TOKEN_INVALID0" ||
        res.error === "ERROR_TOKEN_INVALID1" ||
        res.error === "user not registered" ||
        res.error === "ERROR_TOKEN_INVALID2" ||
        res.error === "ERROR_TOKEN_INVALID3" ||
        res.error === "unauthorized" ||
        res.error === "Your session has expierd Please login again 1" ||
        res.error === "Your session has expierd Please login again 2")
    ) {
      window.localStorage.removeItem("_A");
      window.localStorage.removeItem("_B");
      window.localStorage.removeItem("_C");
      navigate("/admin/login");
    } else if (res.error) {
      toast.warning(res.error, { autoClose: 2000 });
    } else {
      toast.warning(res.msg, {
        autoClose: 2000
      });
    }
  }
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div id="layout-wrapper">
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-18">Incentive</h4>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="table-responsive">
                        <div className="d-flex justify-content-between">
                          <h4 className="card-title table-head">
                            Incentive Report
                          </h4>
                          <select
                            name="type"
                            className="level-option  card-title2"
                            onChange={e => SearchCore(e.target.value)}
                          >
                            <option value={3}>
                              {" "}
                              &nbsp;&nbsp;All&nbsp;&nbsp;
                            </option>
                            <option value={1}>
                              {" "}
                              &nbsp;&nbsp;Core A&nbsp;&nbsp;
                            </option>
                            <option value={2}>
                              {" "}
                              &nbsp;&nbsp;Core B&nbsp;&nbsp;
                            </option>
                          </select>
                        </div>
                        <div class="input-group">
                          <div
                            class="form-outline mb-2"
                            style={{ marginTop: "1.2rem" }}
                          >
                            <input
                              type="number"
                              name="id"
                              class="form-control"
                              placeholder="Enter Username..."
                              onChange={e => searchChange(e)}
                              value={search}
                            />
                          </div>

                          <div
                            style={{
                              marginTop: "1.35rem",
                              background: "#4cad89",
                              border: "none"
                            }}
                            className="mb-2"
                          >
                            <button
                              type="button"
                              class="btn"
                              onClick={() => Search()}
                            >
                              <i
                                class="fas fa-search"
                                aria-hidden="true"
                                style={{ color: "#fff" }}
                              ></i>
                            </button>
                          </div>
                        </div>

                        <div className="table-responsive table-line">
                          <table
                            className="table align-middle mb-0"
                            id="order-listing"
                          >
                            <thead>
                              <tr>
                                <th>S NO.</th>
                                <th>Member Name</th>
                                <th>userName</th>
                                <th>Tallwin ID</th>
                                <th>Core</th>
                                <th>Incentive</th>
                                <th>Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {searchData && searchData?.length > 0 ? (
                                searchData
                                  .sort(function (a, b) {
                                    return b.created_at - a.created_at;
                                  })
                                  .map((details, i) => {
                                    return (
                                      <tr>
                                        <th scope="row">{i + 1}</th>
                                        <td>
                                          {details.member_details?.length > 0
                                            ? details.member_details[0].name
                                            : "-"}
                                        </td>
                                        <td>{details.userName}</td>
                                        <td>
                                          {details.member_details.length > 0
                                            ? details.member_details[0]
                                                .twlUserName
                                              ? details.member_details[0]
                                                  .twlUserName
                                              : "--"
                                            : "-"}
                                        </td>
                                        <td>{details.core == 1 ? "A" : "B"}</td>
                                        <td>{details.coin}</td>
                                        <td>{details.date}</td>
                                      </tr>
                                    );
                                  })
                              ) : (
                                <p>NO DATA</p>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
}

export default IncentiveReport;
